import { ReservationService } from "./../../services/reservation-service/reservation.service";
import {
  Component,
  OnInit,
  AfterViewInit,
  ViewChildren,
  QueryList,
  ViewChild,
} from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { SlimLoadingBarService } from "ng2-slim-loading-bar";
import { ChartDataSets, ChartOptions } from "chart.js";
import { Color } from "ng2-charts";

import { environment } from "../../../environments/environment";
import { Subscription } from "rxjs";
import { Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { LanguageService } from "../../services/i18n/language.service";

// import { OptionsInput } from '@fullcalendar/core';
// import dayGridPlugin from '@fullcalendar/daygrid';
// import interactionPlugin from '@fullcalendar/interaction';
// import { CalendarComponent } from 'ng-fullcalendar';

@Component({
  selector: "app-accountant-dashboard",
  templateUrl: "./accountant-dashboard.component.html",
  styleUrls: ["./accountant-dashboard.component.scss"],
  providers: [SlimLoadingBarService],
})
export class AccountantDashboardComponent implements OnInit {
  viewPaymentCardsSlider = {
    Today_payment_collections: {
      value: -1,
      change: true,
    },
    MTD_payment_collections: {
      value: -1,
      change: true,
    },
    YTD_payment_collections: {
      value: -1,
      change: true,
    },
    Accumulative_payment_collections: {
      value: -1,
      change: true,
    },
  };

  //#region  Definitions
  channels: any;
  selectedChannel: any;

  projects: any;
  selectedProject: any;
  selectedProject_filter: any;
  users: [];
  selectedUser: any = {};
  selectedYear: any = {};
  selectedMonth: any = {};
  waletTarget: any;
  rangeDates: Date[];

  userData: any;

  statsData: any = {
    salesPipelineStats: null,
    inventoryStats: null,
    paymentCollectedPipelineStats: null,
    paymentCollectionPipelineStas: null,
    collectedTypePipelineStats: null,
  };

  lineChartsData: {
    salesActivity: ChartDataSets[];
    monthlySales: ChartDataSets[];
  } = {
    salesActivity: [],
    monthlySales: [],
  };

  lineChartsLabels = {
    salesActivity: [],
    monthlySales: [],
  };

  lineChartsOptions: {
    salesActivity: ChartOptions;
    monthlySales: ChartOptions;
  } = {
    salesActivity: {
      responsive: true,
      maintainAspectRatio: false,
      elements: {
        line: {
          fill: false,
          tension: 0,
        },
      },
    },
    monthlySales: {
      responsive: true,
      maintainAspectRatio: false,
      elements: {
        line: {
          fill: false,
        },
      },
    },
  };

  lineChartsColors: { salesActivity: Color[]; monthlySales: Color[] } = {
    salesActivity: [
      {
        backgroundColor: "#786fa6",
        borderColor: "#786fa6",
        pointBackgroundColor: "#fff",
        pointBorderColor: "#786fa6",
        pointHoverBackgroundColor: "#786fa6",
        pointHoverBorderColor: "#fff",
      },
      {
        backgroundColor: "#f8a5c2",
        borderColor: "#f8a5c2",
        pointBackgroundColor: "#fff",
        pointBorderColor: "#f8a5c2",
        pointHoverBackgroundColor: "#f8a5c2",
        pointHoverBorderColor: "#fff",
      },
      {
        backgroundColor: "#63cdda",
        borderColor: "#63cdda",
        pointBackgroundColor: "#fff",
        pointBorderColor: "#63cdda",
        pointHoverBackgroundColor: "#63cdda",
        pointHoverBorderColor: "#fff",
      },
      {
        backgroundColor: "#ea8685",
        borderColor: "#ea8685",
        pointBackgroundColor: "#fff",
        pointBorderColor: "#ea8685",
        pointHoverBackgroundColor: "#ea8685",
        pointHoverBorderColor: "#fff",
      },
      {
        backgroundColor: "#596275",
        borderColor: "#596275",
        pointBackgroundColor: "#fff",
        pointBorderColor: "#596275",
        pointHoverBackgroundColor: "#596275",
        pointHoverBorderColor: "#fff",
      },
      {
        backgroundColor: "#546de5",
        borderColor: "#546de5",
        pointBackgroundColor: "#fff",
        pointBorderColor: "#546de5",
        pointHoverBackgroundColor: "#546de5",
        pointHoverBorderColor: "#fff",
      },
      {
        backgroundColor: "#f19066",
        borderColor: "#f19066",
        pointBackgroundColor: "#fff",
        pointBorderColor: "#f19066",
        pointHoverBackgroundColor: "#f19066",
        pointHoverBorderColor: "#fff",
      },
    ],
    monthlySales: [
      {
        backgroundColor: "#78e08f",
        borderColor: "#78e08f",
        pointBackgroundColor: "#fff",
        pointBorderColor: "#78e08f",
        pointHoverBackgroundColor: "#78e08f",
        pointHoverBorderColor: "#fff",
      },
      {
        backgroundColor: "#3c6382",
        borderColor: "#3c6382",
        pointBackgroundColor: "#fff",
        pointBorderColor: "#3c6382",
        pointHoverBackgroundColor: "#3c6382",
        pointHoverBorderColor: "#fff",
      },
      {
        backgroundColor: "#1e3799",
        borderColor: "#1e3799",
        pointBackgroundColor: "#fff",
        pointBorderColor: "#1e3799",
        pointHoverBackgroundColor: "#1e3799",
        pointHoverBorderColor: "#fff",
      },
    ],
  };

  // BAR CHARTS

  barChartsData: {
    availableInventory: ChartDataSets[];
    soldInventory: ChartDataSets[];
  } = {
    availableInventory: [],
    soldInventory: [],
  };

  barChartsLabels = {
    availableInventory: [],
    soldInventory: [],
  };

  barChartsOptions: {
    availableInventory: ChartOptions;
    soldInventory: ChartOptions;
  } = {
    availableInventory: {
      responsive: true,
      maintainAspectRatio: false,
      barRoundness: 1,
      // We use these empty structures as placeholders for dynamic theming.
      scales: { xAxes: [{}], yAxes: [{}] },
      plugins: {
        datalabels: {
          anchor: "end",
          align: "end",
        },
      },
    },
    soldInventory: {
      responsive: true,
      maintainAspectRatio: false,
      barRoundness: 1,
      // We use these empty structures as placeholders for dynamic theming.
      scales: { xAxes: [{}], yAxes: [{}] },
      plugins: {
        datalabels: {
          anchor: "end",
          align: "end",
        },
      },
    },
  };

  barChartsColors: Color[] = [
    {
      backgroundColor: "#001f3f",
      borderColor: "#001f3f",
      pointBackgroundColor: "#fff",
      pointBorderColor: "#001f3f",
      pointHoverBackgroundColor: "#001f3f",
      pointHoverBorderColor: "#fff",
    },
    {
      backgroundColor: "#0074D9",
      borderColor: "#0074D9",
      pointBackgroundColor: "#fff",
      pointBorderColor: "#0074D9",
      pointHoverBackgroundColor: "#0074D9",
      pointHoverBorderColor: "#fff",
    },
    {
      backgroundColor: "#7FDBFF",
      borderColor: "#7FDBFF",
      pointBackgroundColor: "#fff",
      pointBorderColor: "#7FDBFF",
      pointHoverBackgroundColor: "#7FDBFF",
      pointHoverBorderColor: "#fff",
    },
    {
      backgroundColor: "#39CCCC",
      borderColor: "#39CCCC",
      pointBackgroundColor: "#fff",
      pointBorderColor: "#39CCCC",
      pointHoverBackgroundColor: "#39CCCC",
      pointHoverBorderColor: "#fff",
    },
    {
      backgroundColor: "#3D9970",
      borderColor: "#3D9970",
      pointBackgroundColor: "#fff",
      pointBorderColor: "#3D9970",
      pointHoverBackgroundColor: "#3D9970",
      pointHoverBorderColor: "#fff",
    },
    {
      backgroundColor: "#2ECC40",
      borderColor: "#2ECC40",
      pointBackgroundColor: "#fff",
      pointBorderColor: "#2ECC40",
      pointHoverBackgroundColor: "#2ECC40",
      pointHoverBorderColor: "#fff",
    },
    {
      backgroundColor: "#01FF70",
      borderColor: "#01FF70",
      pointBackgroundColor: "#fff",
      pointBorderColor: "#01FF70",
      pointHoverBackgroundColor: "#01FF70",
      pointHoverBorderColor: "#fff",
    },
    {
      backgroundColor: "#FFDC00",
      borderColor: "#FFDC00",
      pointBackgroundColor: "#fff",
      pointBorderColor: "#FFDC00",
      pointHoverBackgroundColor: "#FFDC00",
      pointHoverBorderColor: "#fff",
    },
    {
      backgroundColor: "#FF851B",
      borderColor: "#FF851B",
      pointBackgroundColor: "#fff",
      pointBorderColor: "#FF851B",
      pointHoverBackgroundColor: "#FF851B",
      pointHoverBorderColor: "#fff",
    },
    {
      backgroundColor: "#FF4136",
      borderColor: "#FF4136",
      pointBackgroundColor: "#fff",
      pointBorderColor: "#FF4136",
      pointHoverBackgroundColor: "#FF4136",
      pointHoverBorderColor: "#fff",
    },
    {
      backgroundColor: "#85144b",
      borderColor: "#85144b",
      pointBackgroundColor: "#fff",
      pointBorderColor: "#85144b",
      pointHoverBackgroundColor: "#85144b",
      pointHoverBorderColor: "#fff",
    },
    {
      backgroundColor: "#F012BE",
      borderColor: "#F012BE",
      pointBackgroundColor: "#fff",
      pointBorderColor: "#F012BE",
      pointHoverBackgroundColor: "#F012BE",
      pointHoverBorderColor: "#fff",
    },
    {
      backgroundColor: "#B10DC9",
      borderColor: "#B10DC9",
      pointBackgroundColor: "#fff",
      pointBorderColor: "#B10DC9",
      pointHoverBackgroundColor: "#B10DC9",
      pointHoverBorderColor: "#fff",
    },
  ];

  newsData: any;

  // news items to detect if rendered
  @ViewChildren("newsElementContainer") newsElement: QueryList<any>;
  newsIsLoading = true;
  shoroukNewsIsLoading = false;
  mubasherNewsIsLoading = false;
  almasryNewsIsLoading = false;
  almalNewsIsLoading = false;

  newsChangesSubscription: Subscription;
  //#endregion

  payment_collections = [];
  partially_methods = ["Cash", "Visa", "Transfer", "Cheque"];

  lang: string = "en";

  elapse_collection_pipeline: boolean = false;
  elapse_collection_type_pipeline: boolean = false;

  salesFilter = {
    year: null,
    month: null,
    day: null,
  };
  activeYear = new Date().getFullYear();

  constructor(
    private slimLoadingBarService: SlimLoadingBarService,
    private reservationService: ReservationService,
    private http: HttpClient,
    private router: Router,
    private translate: TranslateService,
    private languageService: LanguageService
  ) {
    this.lang = this.languageService.getCurrentLang();
  }

  ngOnInit() {
    this.translate.onLangChange.subscribe(() => {
      this.lang = this.languageService.getCurrentLang();
    });
    this.userData = JSON.parse(localStorage.getItem("userProfile"));
    this.getUsers();
    this.getInitialFilter();
    this.getLeadChannels();
    this.getListProjects();
    this.filterDashboard();
    this.getPaymentCollections();
  }

  //#region get loaded methods

  getPaymentCollections() {
    this.slimLoadingBarService.start();
    this.reservationService.getAllPaymentCollections().subscribe(
      (res: any) => {
        this.slimLoadingBarService.complete();
        this.payment_collections = res.data.map((c) => {
          c.collect_types = Array.from(
            new Set(c.receipts.map((r) => r.type_string))
          ).join(", ");
          return c;
        });
      },
      (err) => {
        this.slimLoadingBarService.reset();
      }
    );
  }

  getLeadChannels() {
    this.http.get(`${environment.api_base_url}lead_channels`).subscribe(
      (data) => {
        this.channels = data;
      },
      (err) => {
        console.log(err);
      }
    );
  }

  getListProjects() {
    this.reservationService.getProjects({ is_select_form: true }).subscribe(
      (data) => {
        this.projects = data;
      },
      (err) => {
        console.log(err);
      }
    );
  }

  getChartsSalesActivities() {
    this.http
      .get(`${environment.api_base_url}dashboard/charts/sales_activity`)
      .subscribe(
        (data: any) => {
          this.lineChartsLabels.salesActivity = [...data.months];
          this.lineChartsData.salesActivity = [...data.results];
        },
        (err) => {
          console.log(err);
        }
      );
  }

  getChartsSalesReservations() {
    this.http
      .get(`${environment.api_base_url}dashboard/charts/sales_reservations`)
      .subscribe(
        (data: any) => {
          this.lineChartsLabels.monthlySales = [...data.months];
          this.lineChartsData.monthlySales = [...data.results];
        },
        (err) => {
          console.log(err);
        }
      );
  }

  getChartsAvailableInventory() {
    this.http
      .get(`${environment.api_base_url}dashboard/charts/available_inventory`)
      .subscribe(
        (data: any) => {
          this.barChartsLabels.availableInventory = [...data.months];
          this.barChartsData.availableInventory = [...data.results];
        },
        (err) => {
          console.log(err);
        }
      );
  }

  getChartsSoldInventory() {
    this.http
      .get(`${environment.api_base_url}dashboard/charts/sold_inventory`)
      .subscribe(
        (data: any) => {
          this.barChartsLabels.soldInventory = [...data.months];
          this.barChartsData.soldInventory = [...data.results];
        },
        (err) => {
          console.log(err);
        }
      );
  }

  getNews() {}

  getInitialFilter() {
    let date = new Date();
    this.selectedMonth = {
      value: date.getMonth() + 1,
      name: date.toLocaleDateString("en", { month: "long" }),
    };
    this.selectedYear = {
      value: date.getFullYear(),
      name: date.getFullYear(),
    };
    this.getTarget(this.selectedMonth.value, this.selectedYear.value);
  }

  getUsers() {
    this.http.get(`${environment.api_base_url}users/get_agents`).subscribe(
      (data: any) => {
        this.users = data;
        console.log("users : ", this.users);
      },
      (err) => {
        console.log(err);
      }
    );
  }

  getYears() {
    const now = new Date().getUTCFullYear();
    return Array(10)
      .fill("")
      .map((v, idx) => ({ name: now - idx, value: now - idx }));
  }

  getMonths() {
    let month = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    // let month = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul","Aug", "Sep", "Oct", "Nov", "Dec"];
    return month.map((v, idx) => ({ value: idx + 1, name: v }));
  }

  getTarget(month?: number, year?: number, project?: number, userId?: number) {
    let params = {
      month: month,
      year: year,
      project_id: project,
      user_id: userId,
    };
    this.http
      .get(`${environment.api_base_url}dashboard/current_target`, {
        params: Object.entries(params)
          .filter(([key, val]) => val !== undefined)
          .reduce((obj, [key, val]) => {
            obj[key] = `${val}`;
            return obj;
          }, {}),
      })
      .subscribe(
        (data) => {
          this.waletTarget = data;
          console.log("target : ", this.waletTarget);
        },
        (err) => {
          console.log(err);
        }
      );
  }

  exportTarget() {
    let params = {
      month: this.selectedMonth ? this.selectedMonth.value : "",
      year: this.selectedYear ? this.selectedYear.value : "",

      userId: this.selectedUser ? this.selectedUser.id : "",
    };
    this.http
      .get(`${environment.api_base_url}dashboard/export_target`, {
        responseType: "blob",
        params: Object.entries(params)
          .filter(([key, val]) => val !== undefined)
          .reduce((obj, [key, val]) => {
            obj[key] = val;
            return obj;
          }, {}),
      })
      .subscribe(
        (response) => {
          let fileUrl = window.URL.createObjectURL(response);
          window.open(fileUrl);
        },
        (err) => {
          console.log("error :", err);
        }
      );
  }

  //#endregion

  //#region OnChange methods
  onChannelChange() {
    this.filterDashboard();
  }

  onChangeDatePicker() {
    this.filterDashboard();
  }

  onProjectChange() {
    this.filterDashboard();
  }

  onChangeFilter(year?: any, month?: any, project?: any, user?: any) {
    this.selectedYear = year || "";
    this.selectedMonth = month || "";
    this.selectedProject_filter = project || "";
    this.selectedUser = user || "";
    this.getTarget(
      this.selectedMonth ? this.selectedMonth.value : "",
      this.selectedYear ? this.selectedYear.value : "",
      this.selectedProject_filter ? this.selectedProject_filter.id : "",
      this.selectedUser ? this.selectedUser.id : ""
    );
  }

  //#endregion

  filterDashboard() {
    const params = {
      channel_id: this.selectedChannel ? this.selectedChannel.id : "",
      date_picker: JSON.stringify(this.rangeDates),
      project_id: this.selectedProject ? this.selectedProject.id : "",
      date_year: this.salesFilter.year ? this.salesFilter.year.value : "",
      date_month: this.salesFilter.month ? this.salesFilter.month.value : "",
      date_day: this.salesFilter.day ? this.salesFilter.day.value : "",
    };

    this.filterSalesPipeline(params);
    this.filterInventoryPipeline(params);
    this.filterPaymentCollectedPipeline(params);
    this.filterPaymentCollectionPipeline(params);
    this.filterCollectedTypePipelineStatsPipeline(params);
    this.filterInstallmentPipeline(params);
  }

  filterSalesPipeline(params) {
    this.http
      .get(`${environment.api_base_url}dashboard/salesPipelineStats`, {
        params,
      })
      .subscribe((res) => {
        this.statsData.salesPipelineStats = res;
      });
  }

  filterInventoryPipeline(params) {
    this.http
      .get(`${environment.api_base_url}dashboard/inventoryStats`, {
        params,
      })
      .subscribe((res) => {
        this.statsData.inventoryStats = res;
      });
  }

  filterInstallmentPipeline(params) {
    this.http
      .get(
        `${environment.api_base_url}dashboard/paymentCollectedPipelineStats`,
        {
          params,
        }
      )
      .subscribe((res) => {
        this.statsData.installmentCollectedPipelineStats = res;
        // Object.keys(this.viewPaymentCardsSlider).map((type) => {
        // this.startPaymentCardsSlider(type, true);
        // });
      });
  }

  filterPaymentCollectedPipeline(params) {
    this.http
      .get(
        `${environment.api_base_url}dashboard/paymentCollectedPipelineStats`,
        {
          params,
        }
      )
      .subscribe((res) => {
        this.statsData.paymentCollectedPipelineStats = res;
        // Object.keys(this.viewPaymentCardsSlider).map((type) => {
        //   this.startPaymentCardsSlider(type, true);
        // });
      });
  }

  onGoPageTop() {
    document.body.scrollTop = document.documentElement.scrollTop = 0;
  }

  reloadNews(newsName) {
    if (newsName) {
      switch (newsName) {
        case "almalnews":
          this.almalNewsIsLoading = true;
          break;
        case "almasryalyoum":
          this.almasryNewsIsLoading = true;
          break;
        case "mubasher":
          this.mubasherNewsIsLoading = true;
          break;
        case "shorouknews":
          this.shoroukNewsIsLoading = true;
          break;
      }
    }
  }

  onLeadStatusClicked(lead_status) {
    if (!lead_status) {
      return;
    }

    const statusName = (lead_status.status || lead_status.name || "")
      .toString()
      .trim();
    const normalizedStatusName = statusName.toLowerCase();
    const isAllStatus =
      normalizedStatusName === "all" || normalizedStatusName === "total";
    if (isAllStatus) {
      this.router.navigate(["/pages/leads"]);
      return;
    }

    if (!statusName) {
      return;
    }

    const queryParams: any = {
      status_name: statusName,
    };
    if (lead_status.status_id || lead_status.id) {
      queryParams.status_id = lead_status.status_id || lead_status.id;
    }
    if (this.selectedChannel) {
      queryParams.channel = JSON.stringify(this.selectedChannel);
    }

    this.router.navigate(["/pages/leads"], {
      queryParams,
    });
  }

  goToLeadsWithActivity(lead_activity) {
    this.router.navigate(["/pages/leads"], {
      queryParams: {
        activity_name: lead_activity.title,
      },
    });
  }

  goToLead(lead) {
    this.router.navigate(["/pages/leads"], {
      queryParams: {
        lead_id: lead.id,
      },
    });
  }

  // PaymentCardsSlider
  // paymentCardsSliderValues = ["all", "collected", "rejected", "remaining"];
  // timeouts = {};
  // startPaymentCardsSlider(type, first = false) {
  //   if (first || this.timeouts[type] === null) {
  //     this.timeouts[type] = setInterval(() => {
  //       this.viewPaymentCardsSlider[type].change = true;
  //       setTimeout(() => {
  //         this.viewPaymentCardsSlider[type].value =
  //           (this.viewPaymentCardsSlider[type].value + 1) %
  //           this.paymentCardsSliderValues.length;
  //         this.viewPaymentCardsSlider[type].change = false;
  //       }, 500);
  //     }, 3000);
  //   }
  // }

  // stopPaymentCardsSlider(type) {
  //   if (this.timeouts[type]) {
  //     clearInterval(this.timeouts[type]);
  //     this.timeouts[type] = null;
  //     this.viewPaymentCardsSlider[type].change = false;
  //   }
  // }

  switchLang(lang: string) {
    this.languageService.use(lang);
    this.lang = this.languageService.getCurrentLang();
  }

  goToUnits(filters?) {
    if (filters) {
      switch (filters) {
        case "available":
          this.router.navigateByUrl("/pages/projects/units/0?status=available");
          break;
        case "blocked":
          this.router.navigateByUrl("/pages/projects/units/0?status=Blocked");
          break;
        default:
          break;
      }
      return;
    }
    this.router.navigateByUrl("/pages/projects/units/0");
  }

  goToReservations(filters?) {
    if (filters) {
      switch (filters) {
        case "pending":
          this.router.navigateByUrl(
            "pages/reservations?selectedContractStatuses=pending&is_gift=0&is_shareholder=0"
          );
          break;
        case "Contracted":
          this.router.navigateByUrl(
            "pages/reservations?selectedStatuses=Contracted&is_gift=0&is_shareholder=0"
          );
          break;
        default:
          break;
      }
      return;
    }

    this.router.navigateByUrl(
      "pages/reservations?selectedStatuses=Accountant Approved&is_gift=0&is_shareholder=0"
    );
  }

  goToReservationToday() {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");
    const formattedDate = `${year}-${month}-${day}`;
    this.router.navigateByUrl(
      `pages/reservations?date_from=${formattedDate}&date_to=${formattedDate}&selectedStatuses=Accountant Approved&is_gift=0&is_shareholder=0`
    );
  }

  goToReservationToMonth() {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0"); // Month is 0-based, so add 1
    const day = String(today.getDate()).padStart(2, "0");
    const currMonth = `${year}-${month}-01`;
    const currDate = `${year}-${month}-${day}`;
    this.router.navigateByUrl(
      `pages/reservations?date_from=${currMonth}&date_to=${currDate}&selectedStatuses=Accountant Approved&is_gift=0&is_shareholder=0`
    );
  }

  goToReservationToYear() {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0"); // Month is 0-based, so add 1
    const day = String(today.getDate()).padStart(2, "0");
    const currYear = `${year}-01-01`;
    const currDate = `${year}-${month}-${day}`;
    this.router.navigateByUrl(
      `pages/reservations?date_from=${currYear}&date_to=${currDate}&selectedStatuses=Accountant Approved&is_gift=0&is_shareholder=0`
    );
  }

  goToPaymentCollection(status?) {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");
    const currentDate = `${year}-${month}-${day}`;
    switch (status) {
      case "collected":
        this.router.navigateByUrl(
          `pages/payment-collections?filter_collect_date_from=${currentDate}&filter_collect_date_to=${currentDate}&status=fully-collected`
        );
        break;
      case "bounced":
        this.router.navigateByUrl(
          `pages/payment-collections?filter_bounce_date_from=${currentDate}&filter_bounce_date_to=${currentDate}&status=bounced`
        );
        break;
      case "under-collection":
        this.router.navigateByUrl(
          `pages/payment-collections?filter_date_from=${currentDate}&filter_date_to=${currentDate}&status=under-collection`
        );
        break;
    }
    if (!status) {
      this.router.navigateByUrl(
        `pages/payment-collections?filter_collect_date_from=${currentDate}&filter_collect_date_to=${currentDate}`
      );
    }
  }

  goToPaymentCollectionMonthly(status?) {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");
    const currMonth = `${year}-${month}-01`;
    const currentDate = `${year}-${month}-${day}`;
    switch (status) {
      case "collected":
        this.router.navigateByUrl(
          `pages/payment-collections?filter_collect_date_from=${currMonth}&filter_collect_date_to=${currentDate}&status=fully-collected`
        );
        break;
      case "bounced":
        this.router.navigateByUrl(
          `pages/payment-collections?filter_bounce_date_from=${currMonth}&filter_bounce_date_to=${currentDate}&status=bounced`
        );
        break;
      case "under-collection":
        this.router.navigateByUrl(
          `pages/payment-collections?filter_date_from=${currMonth}&filter_date_to=${currentDate}&status=under-collection`
        );
        break;
    }
    if (!status) {
      this.router.navigateByUrl(
        `pages/payment-collections?filter_collect_date_from=${currMonth}&filter_collect_date_to=${currentDate}`
      );
    }
  }

  goToPaymentCollectionYear(status?) {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");
    const currYear = `${year}-01-01`;
    const currentDate = `${year}-${month}-${day}`;
    switch (status) {
      case "collected":
        this.router.navigateByUrl(
          `pages/payment-collections?filter_collect_date_from=${currYear}&filter_collect_date_to=${currentDate}&status=fully-collected`
        );
        break;
      case "bounced":
        this.router.navigateByUrl(
          `pages/payment-collections?filter_bounce_date_from=${currYear}&filter_bounce_date_to=${currentDate}&status=bounced`
        );
        break;
      case "under-collection":
        this.router.navigateByUrl(
          `pages/payment-collections?filter_date_from=${currYear}&filter_date_to=${currentDate}&status=under-collection`
        );
        break;
    }
    if (!status) {
      this.router.navigateByUrl(
        `pages/payment-collections?filter_collect_date_from=${currYear}&filter_collect_date_to=${currentDate}`
      );
    }
  }

  goToPaymentCollectionAcc(status?) {
    switch (status) {
      case "collected":
        this.router.navigateByUrl(
          `pages/payment-collections?status=fully-collected`
        );
        break;
      case "bounced":
        this.router.navigateByUrl(`pages/payment-collections?status=bounced`);
        break;
      case "under-collection":
        this.router.navigateByUrl(
          `pages/payment-collections?status=under-collection`
        );
        break;
    }
    if (!status) {
      this.router.navigateByUrl(`pages/payment-collections`);
    }
  }

  filterPaymentCollectionPipeline(params) {
    this.http
      .get(`${environment.api_base_url}dashboard/collectedPipelineStats`, {
        params,
      })
      .subscribe((res) => {
        this.statsData.paymentCollectionPipelineStas = res;
      });
  }

  filterCollectedTypePipelineStatsPipeline(params) {
    this.http
      .get(`${environment.api_base_url}dashboard/collectedTypePipelineStats`, {
        params,
      })
      .subscribe((res) => {
        this.statsData.collectedTypePipelineStats = res;
      });
  }

  goToCollectionPipeline(status?) {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");
    const currMonth = `${year}-${month}-01`;
    const currentDate = `${year}-${month}-${day}`;
    switch (status) {
      case "Cash":
        this.router.navigateByUrl(
          `pages/payment-collections?filter_collect_date_from=${currMonth}&filter_collect_date_to=${currentDate}&types=1`
        );
        break;
      case "Cash instead of cheque":
        this.router.navigateByUrl(
          `pages/payment-collections?filter_bounce_date_from=${currMonth}&filter_bounce_date_to=${currentDate}&types=8`
        );
        break;
      case "Cheque":
        this.router.navigateByUrl(
          `pages/payment-collections?filter_bounce_date_from=${currMonth}&filter_bounce_date_to=${currentDate}&types=4`
        );
        break;
      case "Commission Settlement":
        this.router.navigateByUrl(
          `pages/payment-collections?filter_bounce_date_from=${currMonth}&filter_bounce_date_to=${currentDate}&types=5`
        );
        break;
      case "Share Holder Settlement":
        this.router.navigateByUrl(
          `pages/payment-collections?filter_bounce_date_from=${currMonth}&filter_bounce_date_to=${currentDate}&types=6`
        );
        break;
      case "Transfer":
        this.router.navigateByUrl(
          `pages/payment-collections?filter_bounce_date_from=${currMonth}&filter_bounce_date_to=${currentDate}&types=3`
        );
        break;
      case "Vendor Settlement":
        this.router.navigateByUrl(
          `pages/payment-collections?filter_bounce_date_from=${currMonth}&filter_bounce_date_to=${currentDate}&types=7`
        );
        break;
      case "Visa":
        this.router.navigateByUrl(
          `pages/payment-collections?filter_bounce_date_from=${currMonth}&filter_bounce_date_to=${currentDate}&types=2`
        );
        break;
    }
    if (!status) {
      this.router.navigateByUrl(
        `pages/payment-collections?filter_collect_date_from=${currMonth}&filter_collect_date_to=${currentDate}`
      );
    }
  }

  goToCollectionPipelineMonthly(status?) {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");
    const currMonth = `${year}-${month}-01`;
    const currentDate = `${year}-${month}-${day}`;
    switch (status) {
      case "Cash":
        this.router.navigateByUrl(
          `pages/payment-collections?filter_collect_date_from=${currMonth}&filter_collect_date_to=${currentDate}&types=1`
        );
        break;
      case "Cash instead of cheque":
        this.router.navigateByUrl(
          `pages/payment-collections?filter_bounce_date_from=${currMonth}&filter_bounce_date_to=${currentDate}&types=8`
        );
        break;
      case "Cheque":
        this.router.navigateByUrl(
          `pages/payment-collections?filter_bounce_date_from=${currMonth}&filter_bounce_date_to=${currentDate}&types=4`
        );
        break;
      case "Commission Settlement":
        this.router.navigateByUrl(
          `pages/payment-collections?filter_bounce_date_from=${currMonth}&filter_bounce_date_to=${currentDate}&types=5`
        );
        break;
      case "Share Holder Settlement":
        this.router.navigateByUrl(
          `pages/payment-collections?filter_bounce_date_from=${currMonth}&filter_bounce_date_to=${currentDate}&types=6`
        );
        break;
      case "Transfer":
        this.router.navigateByUrl(
          `pages/payment-collections?filter_bounce_date_from=${currMonth}&filter_bounce_date_to=${currentDate}&types=3`
        );
        break;
      case "Vendor Settlement":
        this.router.navigateByUrl(
          `pages/payment-collections?filter_bounce_date_from=${currMonth}&filter_bounce_date_to=${currentDate}&types=7`
        );
        break;
      case "Visa":
        this.router.navigateByUrl(
          `pages/payment-collections?filter_bounce_date_from=${currMonth}&filter_bounce_date_to=${currentDate}&types=2`
        );
        break;
    }
    if (!status) {
      this.router.navigateByUrl(
        `pages/payment-collections?filter_collect_date_from=${currMonth}&filter_collect_date_to=${currentDate}`
      );
    }
  }

  goToCollectionPipelineYear(status?) {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");
    const currYear = `${year}-01-01`;
    const currentDate = `${year}-${month}-${day}`;
    switch (status) {
      case "Cash":
        this.router.navigateByUrl(
          `pages/payment-collections?filter_collect_date_from=${currYear}&filter_collect_date_to=${currentDate}&types=1`
        );
        break;
      case "Cash instead of cheque":
        this.router.navigateByUrl(
          `pages/payment-collections?filter_bounce_date_from=${currYear}&filter_bounce_date_to=${currentDate}&types=8`
        );
        break;
      case "Cheque":
        this.router.navigateByUrl(
          `pages/payment-collections?filter_bounce_date_from=${currYear}&filter_bounce_date_to=${currentDate}&types=4`
        );
        break;
      case "Commission Settlement":
        this.router.navigateByUrl(
          `pages/payment-collections?filter_bounce_date_from=${currYear}&filter_bounce_date_to=${currentDate}&types=5`
        );
        break;
      case "Share Holder Settlement":
        this.router.navigateByUrl(
          `pages/payment-collections?filter_bounce_date_from=${currYear}&filter_bounce_date_to=${currentDate}&types=6`
        );
        break;
      case "Transfer":
        this.router.navigateByUrl(
          `pages/payment-collections?filter_bounce_date_from=${currYear}&filter_bounce_date_to=${currentDate}&types=3`
        );
        break;
      case "Vendor Settlement":
        this.router.navigateByUrl(
          `pages/payment-collections?filter_bounce_date_from=${currYear}&filter_bounce_date_to=${currentDate}&types=7`
        );
        break;
      case "Visa":
        this.router.navigateByUrl(
          `pages/payment-collections?filter_bounce_date_from=${currYear}&filter_bounce_date_to=${currentDate}&types=2`
        );
        break;
    }
    if (!status) {
      this.router.navigateByUrl(
        `pages/payment-collections?filter_collect_date_from=${currYear}&filter_collect_date_to=${currentDate}`
      );
    }
  }

  goToCollectionPipelineAcc(status?) {
    switch (status) {
      case "Cash":
        this.router.navigateByUrl(`pages/payment-collections?types=1`);
        break;
      case "Cash instead of cheque":
        this.router.navigateByUrl(`pages/payment-collections?types=8`);
        break;
      case "Cheque":
        this.router.navigateByUrl(`pages/payment-collections?types=4`);
        break;
      case "Commission Settlement":
        this.router.navigateByUrl(`pages/payment-collections?types=5`);
        break;
      case "Share Holder Settlement":
        this.router.navigateByUrl(`pages/payment-collections?types=6`);
        break;
      case "Transfer":
        this.router.navigateByUrl(`pages/payment-collections?types=3`);
        break;
      case "Vendor Settlement":
        this.router.navigateByUrl(`pages/payment-collections?types=7`);
        break;
      case "Visa":
        this.router.navigateByUrl(`pages/payment-collections?types=2`);
        break;
    }
    if (!status) {
      this.router.navigateByUrl(`pages/payment-collections`);
    }
  }

  goToCollectedType(status?) {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");
    const currMonth = `${year}-${month}-01`;
    const currentDate = `${year}-${month}-${day}`;
    switch (status) {
      case "Down Payment":
        this.router.navigateByUrl(
          `pages/payment-collections?filter_collect_date_from=${currMonth}&filter_collect_date_to=${currentDate}&filter_payment_type=1&status=fully-collected`
        );
        break;
      case "Installment":
        this.router.navigateByUrl(
          `pages/payment-collections?filter_collect_date_from=${currMonth}&filter_collect_date_to=${currentDate}&filter_payment_type=2&status=fully-collected`
        );
        break;
      case "Extra":
        this.router.navigateByUrl(
          `pages/payment-collections?filter_collect_date_from=${currMonth}&filter_collect_date_to=${currentDate}&filter_payment_type=3&status=fully-collected`
        );
        break;
      case "Visa Instance":
        this.router.navigateByUrl(
          `pages/payment-collections?filter_collect_date_from=${currMonth}&filter_collect_date_to=${currentDate}&filter_payment_type=4&status=fully-collected`
        );
        break;
      case "CDB":
        this.router.navigateByUrl(
          `pages/payment-collections?filter_collect_date_from=${currMonth}&filter_collect_date_to=${currentDate}&filter_payment_type=5&status=fully-collected`
        );
        break;
      case "Recall Fees":
        this.router.navigateByUrl(
          `pages/payment-collections?filter_collect_date_from=${currMonth}&filter_collect_date_to=${currentDate}&filter_payment_type=6&status=fully-collected`
        );
        break;
      case "EOI":
        this.router.navigateByUrl(
          `pages/payment-collections?filter_collect_date_from=${currMonth}&filter_collect_date_to=${currentDate}&filter_payment_type=7&status=fully-collected`
        );
        break;
      case "Fines":
        this.router.navigateByUrl(
          `pages/fines-list?filter_date_from=${currMonth}&filter_date_to=${currentDate}`
        );
        break;
    }
    if (!status) {
      this.router.navigateByUrl(
        `pages/payment-collections?filter_collect_date_from=${currMonth}&filter_collect_date_to=${currentDate}&status=fully-collected`
      );
    }
  }

  goToCollectedTypeMonthly(status?) {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");
    const currMonth = `${year}-${month}-01`;
    const currentDate = `${year}-${month}-${day}`;
    switch (status) {
      case "Down Payment":
        this.router.navigateByUrl(
          `pages/payment-collections?filter_collect_date_from=${currMonth}&filter_collect_date_to=${currentDate}&filter_payment_type=1&status=fully-collected`
        );
        break;
      case "Installment":
        this.router.navigateByUrl(
          `pages/payment-collections?filter_collect_date_from=${currMonth}&filter_collect_date_to=${currentDate}&filter_payment_type=2&status=fully-collected`
        );
        break;
      case "Extra":
        this.router.navigateByUrl(
          `pages/payment-collections?filter_collect_date_from=${currMonth}&filter_collect_date_to=${currentDate}&filter_payment_type=3&status=fully-collected`
        );
        break;
      case "Visa Instance":
        this.router.navigateByUrl(
          `pages/payment-collections?filter_collect_date_from=${currMonth}&filter_collect_date_to=${currentDate}&filter_payment_type=4&status=fully-collected`
        );
        break;
      case "CDB":
        this.router.navigateByUrl(
          `pages/payment-collections?filter_collect_date_from=${currMonth}&filter_collect_date_to=${currentDate}&filter_payment_type=5&status=fully-collected`
        );
        break;
      case "Recall Fees":
        this.router.navigateByUrl(
          `pages/payment-collections?filter_collect_date_from=${currMonth}&filter_collect_date_to=${currentDate}&filter_payment_type=6&status=fully-collected`
        );
        break;
      case "EOI":
        this.router.navigateByUrl(
          `pages/payment-collections?filter_collect_date_from=${currMonth}&filter_collect_date_to=${currentDate}&filter_payment_type=7&status=fully-collected`
        );
        break;
      case "Fines":
        this.router.navigateByUrl(
          `pages/fines-list?filter_date_from=${currMonth}&filter_date_to=${currentDate}`
        );
        break;
    }
    if (!status) {
      this.router.navigateByUrl(
        `pages/payment-collections?filter_collect_date_from=${currMonth}&filter_collect_date_to=${currentDate}&status=fully-collected`
      );
    }
  }

  goToCollectedTypeYear(status?) {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");
    const currYear = `${year}-01-01`;
    const currentDate = `${year}-${month}-${day}`;
    switch (status) {
      case "Down Payment":
        this.router.navigateByUrl(
          `pages/payment-collections?filter_collect_date_from=${currYear}&filter_collect_date_to=${currentDate}&filter_payment_type=1&status=fully-collected`
        );
        break;
      case "Installment":
        this.router.navigateByUrl(
          `pages/payment-collections?filter_collect_date_from=${currYear}&filter_collect_date_to=${currentDate}&filter_payment_type=2&status=fully-collected`
        );
        break;
      case "Extra":
        this.router.navigateByUrl(
          `pages/payment-collections?filter_collect_date_from=${currYear}&filter_collect_date_to=${currentDate}&filter_payment_type=3&status=fully-collected`
        );
        break;
      case "Visa Instance":
        this.router.navigateByUrl(
          `pages/payment-collections?filter_collect_date_from=${currYear}&filter_collect_date_to=${currentDate}&filter_payment_type=4&status=fully-collected`
        );
        break;
      case "CDB":
        this.router.navigateByUrl(
          `pages/payment-collections?filter_collect_date_from=${currYear}&filter_collect_date_to=${currentDate}&filter_payment_type=5&status=fully-collected`
        );
        break;
      case "Recall Fees":
        this.router.navigateByUrl(
          `pages/payment-collections?filter_collect_date_from=${currYear}&filter_collect_date_to=${currentDate}&filter_payment_type=6&status=fully-collected`
        );
        break;
      case "EOI":
        this.router.navigateByUrl(
          `pages/payment-collections?filter_collect_date_from=${currYear}&filter_collect_date_to=${currentDate}&filter_payment_type=7&status=fully-collected`
        );
        break;
      case "Fines":
        this.router.navigateByUrl(
          `pages/fines-list?filter_date_from=${currYear}&filter_date_to=${currentDate}`
        );
        break;
    }
    if (!status) {
      this.router.navigateByUrl(
        `pages/payment-collections?filter_collect_date_from=${currYear}&filter_collect_date_to=${currentDate}&status=fully-collected`
      );
    }
  }

  goToCollectedTypeAcc(status?) {
    switch (status) {
      case "Down Payment":
        this.router.navigateByUrl(
          `pages/payment-collections?filter_payment_type=1&status=fully-collected`
        );
        break;
      case "All Down Payment":
        this.router.navigateByUrl(
          `pages/payment-collections?filter_payment_type=1`
        );
        break;
      case "Installment":
        this.router.navigateByUrl(
          `pages/payment-collections?filter_payment_type=2&status=fully-collected`
        );
        break;
      case "All Installment":
        this.router.navigateByUrl(
          `pages/payment-collections?filter_payment_type=2`
        );
        break;
      case "Extra":
        this.router.navigateByUrl(
          `pages/payment-collections?filter_payment_type=3&status=fully-collected`
        );
        break;
      case "All Extra":
        this.router.navigateByUrl(
          `pages/payment-collections?filter_payment_type=3`
        );
        break;
      case "Visa Instance":
        this.router.navigateByUrl(
          `pages/payment-collections?filter_payment_type=4&status=fully-collected`
        );
        break;
      case "CDB":
        this.router.navigateByUrl(
          `pages/payment-collections?filter_payment_type=5&status=fully-collected`
        );
        break;
      case "Recall Fees":
        this.router.navigateByUrl(
          `pages/payment-collections?filter_payment_type=6&status=fully-collected`
        );
        break;
      case "EOI":
        this.router.navigateByUrl(
          `pages/payment-collections?filter_payment_type=7&status=fully-collected`
        );
        break;
      case "Fines":
        this.router.navigateByUrl(`pages/fines-list`);
        break;
    }
    if (!status) {
      this.router.navigateByUrl(`pages/payment-collections`);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/dashboard/accountant-dashboard/accountant-dashboard.component.ts